import { checkIsUnknownItemInArray } from '../../utils/typeUtil';
import {
  WJOFL_CHANGE,
  WJOFL_DIRECT,
  WJOFL_CHANGEDIRECT,
  SCOUNT_KBN,
} from '../../constants/properties/const';
import { OSSCFL_LIST } from '../../constants/scoutServiceJob';

export interface ReqParamsApplyJob {
  jid?: string | null;
  scoutlist_id?: string | null;
  record_scoutlist_id?: string | null; // 記録用スカウトリストID
  message_id?: string | null;
  record_message_id?: string | null; // 記録用メッセージID
  carry_id?: string | null;
  mpsc_sid?: string | null;
  tab?: string | null;
  xtab?: string | null;
  fm?: string | null;
  wmuid?: string | null;
  scoutKbn?: string | null;
  jobOfferKind?: string | null;
  jobFlag?: string | null;
  btnH?: string | null;
  btnF?: string | null;
  seminarType?: string | null;
  bnid?: string | null;
  bnnt?: string | null;
  osscfl?: string | null;
  wapid?: string | null;
  wlstid?: string | null;
  wsfid?: string | null;
  recommendID?: string | null;
  KGMmeasures?: string | null;
  hasDirectLink?: boolean | null;
  directLink?: string | null;
  hasCompanyPageLink?: boolean | undefined;
  isCasualInterview?: boolean | undefined; // カジュアル面談か
  worschrsvid?: string | null; // スカウト配信予約ID（OR）
}

export const createApplyUrl = (params: ReqParamsApplyJob) => {
  // 会員登録画面URL作成
  let carryClass = '';
  let entryId = '';
  if (params.jobOfferKind === WJOFL_CHANGE) {
    // 転職支援
    carryClass = 'o';
    entryId = '1';
  } else if (params.jobOfferKind === WJOFL_DIRECT) {
    // 直接応募
    carryClass = 'd';
    entryId = '25';
  } else if (params.jobOfferKind === WJOFL_CHANGEDIRECT) {
    // 転職支援・直接応募
    if (params.jobFlag === WJOFL_CHANGE) {
      // 転職支援
      carryClass = 'o';
      entryId = '1';
    } else if (params.jobFlag === WJOFL_DIRECT) {
      // 直接応募
      carryClass = 'd';
      entryId = '25';
    }
  }

  let url = '';
  // ダイレクトリンク設定済みかつ直接応募か識別し、直接応募フォームURLを設定
  if (params.hasDirectLink && params.jobFlag === WJOFL_DIRECT) {
    // 企業直接リンク設定がONの場合はダイレクトリンクURLをURLに設定
    url = params.directLink || '';
  } else {
    url = `/dcfront/member/memberRegist/?carry_id=${
      params.jid
    }&carry_class=${carryClass}&entry_id=${entryId}&mpsc_sid=${
      params.mpsc_sid
    }&fm=${params.fm}${params.bnid ? `&bnid=${params.bnid}` : ''}`;

    if (
      params.osscfl &&
      checkIsUnknownItemInArray(params.osscfl, OSSCFL_LIST)
    ) {
      url += `&scoutlist_id=${999999900 + Number(params.osscfl)}&message_id=1`;

      // DRスカウトお知らせメールのスカウトリストID
      if (params.wlstid) {
        url += `&dr_wlstid=${params.wlstid}`;
      }
    } else if (params.scoutKbn === SCOUNT_KBN) {
      // OSスカウト区分が設定されていない場合で、スカウト案件の場合
      // スカウトリストIDとメッセージIDを付与
      url += `&scoutlist_id=${params.scoutlist_id}&message_id=${params.message_id}`;
    }

    // スカウト一意証跡データ記録改修 パラメータ追加
    if (params.record_scoutlist_id && params.record_message_id) {
      // 記録用スカウトリストIDと記録用メッセージIDを付与
      url += `&record_scoutlist_id=${params.record_scoutlist_id}&record_message_id=${params.record_message_id}`;
    }

    if (params.recommendID) {
      url += `&recommendID=${params.recommendID}`;
    }
    if (params.KGMmeasures) {
      url += `&KGMmeasures=${params.KGMmeasures}`;
    }

    // カジュアル面談フラグとスカウト配信予約ID（OR） パラメータに追加
    if (params.isCasualInterview) {
      url += `&casual_interview_flg=1`;
    }
    if (params.worschrsvid) {
      url += `&worschrsv_id=${params.worschrsvid}`;
    }
  }

  return url;
};
